module.exports = __webpack_public_path__ + "assets/78726bec299f3bee36dc008bc77bd3e7.png";